import { createSlice } from "@reduxjs/toolkit";

import {  getBrandList  } from "../../reduxApi/admin/BrandReduxApi";

const BrandSlice = createSlice({
  name: "BrandSlice",
  initialState: {
    status: "idle",
    getBrandList: [],
    getBrandCount: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBrandList.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getBrandList = action.payload.data;
      console.log("state.getBrandList", state.getBrandList);
    });
    
  },
});

export default BrandSlice.reducer;
